import { mdiSpeedometer } from '@mdi/js'
import Icon from '@mdi/react'
import { memo } from 'react'
import { palette } from '../styles/colors'

const AutoPlayOptionsIcon = memo(() => (
    <Icon
        data-testid="IconButton__AutoPlayOptionsButton"
        path={mdiSpeedometer}
        size={1}
        color={palette.contrastIcons}
    />
))

export default AutoPlayOptionsIcon
